export default {
    // 人脸认证结果
    faceAuthResults: () => import( /* webpackChunkName: "YzFaceAuthResults" */ '../../views/YZ/FaceAuthenticationResults/index.vue'),
    // 签章
    signature: () => import( /* webpackChunkName: "signature" */ '../../views/YZ/Signature/index.vue'),
    // 融资信息收集
    financingIntention: () => import( /* webpackChunkName: "financingInformationCollection" */ '../../views/YZ/Form/financingIntention.vue'),
    // 闲置设备发布
    idleEquipment: () => import( /* webpackChunkName: "idleEquipmentDemandRelease" */ '../../views/YZ/Form/idleEquipment.vue'),
    // 表单提交结果
    formResults: () => import( /* webpackChunkName: "formResults" */ '../../views/YZ/Form/results.vue'),
    // 告警中心
    warningCenter: () => import( /* webpackChunkName: "formResults" */ '../../views/YZ/warningCenter/index.vue'),
    // 告警中心-视频回放
    video: () => import( /* webpackChunkName: "formResults" */ '../../views/YZ/warningCenter/video.vue'),
    // pdf
    pdfViewer: () => import( /* webpackChunkName: "pdfViewer" */ '../../views/YZ/Viewer/pdf-viewer.vue'),
    // 运营管理平台-登录
    payRecordLogin: () => import( /* webpackChunkName: "pdfViewer" */ '../../views/YZ/payRecord/login.vue'),
    // 运营管理平台-缴费记录列表
    payRecordList: () => import( /* webpackChunkName: "pdfViewer" */ '../../views/YZ/payRecord/payRecordList.vue'),
    // 运营管理平台-详情
    payRecordDetail: () => import( /* webpackChunkName: "pdfViewer" */ '../../views/YZ/payRecord/payRecordDetail.vue'),
    // pdf
    payRecordDetailPDF: () => import( /* webpackChunkName: "pdfViewer" */ '../../views/YZ/payRecord/pdf-viewer.vue'),

    

}